export default __webpack_public_path__ + "static/media/6-mountains-left.711fff96.png";